<template>
  <b-form-group
    :id="id + 'group'"
    :label-for="id"
    :state="state"
    :invalid-feedback="invalidFeedback"
    :description="description"
    :label-cols-sm="labelCols"
    :label-align-sm="labelAlign"
    :content-cols-sm="contentCols"
    :class="'cp-textfield cp-fieldlabel item ' + requiredClass"

  >
    <template #label>
      {{ (label)? label : $t('LABEL.' + fieldname) }}
    </template>
    <div v-if="viewmode" class="view-field">
      {{ value }}
    </div>
    <b-form-input
        v-if="!viewmode"
        class="block"
        type="text"
        :id="id"
        :state="state"
        :value="value"
        :placeholder="placeholder"
        :maxlength="maxlength"
        @input="value => updateValue(value)"
    />
  </b-form-group>
</template>

<script>
import Vue from 'vue'
import commonValidate from '@/mixins/commonValidate.js'

export default {
  mixins: [commonValidate],
  props: {
    id: { type: String, required: true },
    fieldname: { type: String, required: true },
    label: { type: String, default: null, required: false },
    value: { type: String, default: null, required: false },
    placeholder: { type: String, default: '', required: false },
    description: { type: String, default: '', required: false },
    viewmode: { type: Boolean, default: false, required: false },
    minlength: { type: Number, default: 0, required: false },
    maxlength: { type: Number, default: 40, required: false },
    validators: { type: Array, defaule: [], required: false },
    disperror: { type: Boolean, default: false, required: false },
    labelCols: { type: Number, default: 3, required: false },
    labelAlign: { type: String, default: 'left', required: false },
    contentCols: { type: Number, default: 9, required: false }
  },
  setup (props) {
    const data = Vue.util.extend({}, props)
    const labelname = props.label
    const dataValue = props.value
    const dataPlaceholder = props.placeholder
    const dataDescription = props.description
    const requiredClass = props.validators ? (props.validators.indexOf('required') >= 0 ? 'required' : '') : ''
    return {
      data,
      labelname,
      dataValue,
      dataPlaceholder,
      dataDescription,
      requiredClass
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/fields/TextField.vue